import { useReq } from '@/utils/request/useReq'

const pairListUrl = '/order/quickConvert/pair/list'
const quoteUrl = '/order/quickConvert/quote'
const submitUrl = '/order/quickConvert/submit'
const orderPageUrl = '/order/quickConvert/order/page'
const orderDetailUrl = '/order/quickConvert/order/detail'
const accountInfoUrl = '/account/query/info'
const rateToUsdUrl = '/market/rate-to-usd'

const withQuickConvertErrorHandling = config => ({
  ...config,
  silentErrorCodes: [15022, 15084],
  silentErrorMessages: [$t('stock.orderPaused'), '暂停兑换', '暫停兌換'],
  errorMessageMap: {
    '兑换池账户余额查询失败': $t('stock.convertPoolDepthInsufficient'),
  },
})

const pairList = (params = {}, options = {}) =>
  useReq(pairListUrl, withQuickConvertErrorHandling({ method: 'POST', data: params, okCodes: [1, 15084] }), options)

const quote = (params = {}, options = {}) =>
  useReq(quoteUrl, withQuickConvertErrorHandling({ method: 'POST', data: params, okCodes: [1, 15022] }), { immediate: false, ...options })

const submit = (params = {}, options = {}) =>
  useReq(submitUrl, withQuickConvertErrorHandling({ method: 'POST', data: params }), { immediate: false, ...options })

const orderPage = (params = {}, options = {}) =>
  useReq(orderPageUrl, withQuickConvertErrorHandling({ method: 'POST', data: params }), options)

const orderDetail = (params = {}, options = {}) =>
  useReq(orderDetailUrl, withQuickConvertErrorHandling({ method: 'POST', data: params }), { immediate: false, ...options })

const accountInfo = (params = {}, options = {}) =>
  useReq(accountInfoUrl, withQuickConvertErrorHandling({ method: 'POST', data: params }), options)

const rateToUsd = (params = {}, options = {}) =>
  useReq(rateToUsdUrl, withQuickConvertErrorHandling({ method: 'POST', data: params, auth: false }), { immediate: false, ...options })

const needLoginUrl = [submitUrl, orderPageUrl, orderDetailUrl, accountInfoUrl]

export const quickConvertApi = {
  pairList,
  quote,
  submit,
  orderPage,
  orderDetail,
  accountInfo,
  rateToUsd,
  needLoginUrl,
}

export default quickConvertApi
